import { Tabs } from '@mantine/core';
import CompanyWrapper from 'src/company/templates/components/CompanyWrapper';
import { Company } from 'src/secret-menu/hooks/useCompanies';
import { MeetingAgendasTable } from './MeetingAgendasTable';
import { MeetingNotesTable } from './MeetingNotesTable';
import { SuitabilityReportsTable } from './SuitabilityReportsTable';

export default function GeneratedDocumentsTab() {
  return <CompanyWrapper contentComponent={GeneratedDocumentsContent} />;
}

function GeneratedDocumentsContent({ company }: { company: Company }) {
  return (
    <Tabs defaultValue="suitability-reports">
      <Tabs.List>
        <Tabs.Tab value="suitability-reports">Suitability reports</Tabs.Tab>
        <Tabs.Tab value="meeting-notes">Meeting notes</Tabs.Tab>
        <Tabs.Tab value="meeting-agendas">Meeting agendas</Tabs.Tab>
      </Tabs.List>
      <Tabs.Panel value="suitability-reports" pt="md">
        <SuitabilityReportsTable company={company} />
      </Tabs.Panel>
      <Tabs.Panel value="meeting-notes" pt="md">
        <MeetingNotesTable company={company} />
      </Tabs.Panel>
      <Tabs.Panel value="meeting-agendas" pt="md">
        <MeetingAgendasTable company={company} />
      </Tabs.Panel>
    </Tabs>
  );
}
